import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DPIdsReportUseCase extends BaseUseCase {
    constructor(dpTransactionRepo) {
        super();
        this.dpTransactionRepo = dpTransactionRepo;
    }
    async fetchResult(req) {
        return await this.dpTransactionRepo.getDpIds(req);
    }
}
export default DPIdsReportUseCase;
